import {NextSeo} from 'next-seo';

import Section from 'pages/layouts/Section';

import BlogHeader from './BlogHeader';
import BlogPostMetaInfo from './BlogPostMetaInfo';
import SanityPostRenderer from './SanityPostRenderer';

import {MailingListSubscribe} from './MailingListSubscribe';
import SocialInteractionPrompts from './SocialInteractionPrompts';
import {MoreBlogPosts} from './MoreBlogPosts';
import 'highlight.js/styles/github-dark.css';

const BlogPostHeader = ({meta}) => {
  return <>{meta.description && <p className="mb-4 text-2xl">{meta.description}</p>}</>;
};

const getFullURL = (url: string) => {
  const baseURL = `https://${process.env.VERCEL_URL ?? 'www.polarsignals.com'}`;
  if (url.startsWith('//')) {
    return `${baseURL}${url.substring(1)}`;
  }
  if (url.startsWith('/')) {
    return `${baseURL}${url}`;
  }
  return url;
};

export const MarkdownPostRenderer = ({children}) => {
  return <>{children}</>;
};

export const BlogPost = ({
  post,
  children,
  isMarkdown,
  meta,
}: {
  post: any;
  children?: any;
  isMarkdown: boolean;
  meta: any;
}) => {
  return (
    <>
      <NextSeo
        title={meta.title}
        description={meta.description}
        openGraph={{
          title: meta.title,
          description: meta.description,
          type: 'article',
          article: {
            authors: [].concat(meta.authors),
            publishedTime: meta.date,
            tags: [
              'Polar Signals',
              'Profiling',
              'Continuous Profiling',
              'Observability',
              'Monitoring',
            ].concat(meta.tags || []),
          },
          images:
            meta.ogImage || meta.image
              ? [
                  {
                    url: getFullURL(meta.ogImage ?? meta.image),
                  },
                ]
              : [
                  {
                    url: `https://polarsignals.com/api/og?title=${encodeURI(
                      meta.title as string
                    )}&authors=${encodeURI((meta.authors as string[]).join())}&tags=${encodeURI(
                      (meta.tags as string[]).join()
                    )}`,
                  },
                ],
        }}
      />
      <BlogHeader title={meta.title} subTitle={<BlogPostHeader meta={meta} />} image={meta.image} />
      <Section>
        <div className="prose lg:prose-xl grid max-w-none grid-cols-12 gap-4">
          <BlogPostMetaInfo meta={meta} isMarkdown={isMarkdown} />
          <div className="col-span-12 break-words text-justify lg:col-span-8">
            <article>
              {isMarkdown ? (
                <MarkdownPostRenderer>{children}</MarkdownPostRenderer>
              ) : (
                <SanityPostRenderer post={post} />
              )}
            </article>
            <SocialInteractionPrompts
              title={meta.title}
              hnLink={meta.hnLink}
              redditLink={meta.redditLink}
            />
          </div>
        </div>
      </Section>

      <MoreBlogPosts meta={meta} />

      <MailingListSubscribe
        caption="Sign up for the latest Polar&nbsp;Signals news"
        actionURL="https://polarsignals.us2.list-manage.com/subscribe/post?u=2f3e518c3a53f2159fa15ea01&amp;id=6e175695f2"
      />
    </>
  );
};
